const TABLE_COLUMNS = 7;
const TABLE_ROWS = 5;
const MOBILE_CARDS = 3;

const PurchaseSkeleton = () => {
  return (
    <>
      {/* =====================================================
          🔹 Skeleton escritorio
      ===================================================== */}

      <div className="hidden overflow-hidden lg:block">
        <div
          className="
            grid
            grid-cols-[1fr_1.4fr_0.8fr_0.8fr_0.6fr_0.8fr_2fr]
            gap-4

            border-b
            border-stroke

            bg-gray-2

            px-5
            py-4

            dark:border-strokedark
            dark:bg-meta-4/60
          "
        >
          {Array.from({ length: TABLE_COLUMNS }).map(
            (_, index) => (
              <div
                key={index}
                className="
                  h-3

                  animate-pulse

                  rounded

                  bg-bodydark1

                  dark:bg-strokedark
                "
              />
            )
          )}
        </div>

        {Array.from({ length: TABLE_ROWS }).map(
          (_, row) => (
            <div
              key={row}
              className="
                grid
                grid-cols-[1fr_1.4fr_0.8fr_0.8fr_0.6fr_0.8fr_2fr]
                gap-4

                border-b
                border-stroke

                px-5
                py-5

                dark:border-strokedark
              "
            >
              {Array.from({
                length: TABLE_COLUMNS,
              }).map((_, column) => (
                <div
                  key={column}
                  className="
                    h-4

                    animate-pulse

                    rounded

                    bg-gray-2

                    dark:bg-meta-4
                  "
                />
              ))}
            </div>
          )
        )}
      </div>

      {/* =====================================================
          🔹 Skeleton móvil
      ===================================================== */}

      <div
        className="
          grid
          grid-cols-1
          gap-4

          p-5

          sm:px-7
          md:grid-cols-2
          lg:hidden
        "
      >
        {Array.from({ length: MOBILE_CARDS }).map(
          (_, index) => (
            <div
              key={index}
              className="
                h-64

                animate-pulse

                rounded-xl

                border
                border-stroke

                bg-gray-2

                dark:border-strokedark
                dark:bg-meta-4
              "
            />
          )
        )}
      </div>
    </>
  );
};

export default PurchaseSkeleton;